export const REVERSED_FILTER_RANGE_ERROR =
  "Значение «от» не может быть больше значения «до». Измените одно из значений.";

const parseFilterRangeValue = (value: string): number | null => {
  const normalized = value.replace(/\s/g, "").replace(",", ".");
  if (!normalized) return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getFilterRangeError = (
  min: string,
  max: string,
): string | null => {
  const parsedMin = parseFilterRangeValue(min);
  const parsedMax = parseFilterRangeValue(max);

  if (parsedMin === null || parsedMax === null || parsedMin <= parsedMax) {
    return null;
  }

  return REVERSED_FILTER_RANGE_ERROR;
};
